import { apiUrl } from "../services/api";
import { safeProductOrProfileImageSrc } from "./safeMerchantImageFile";

const DEFAULT_THUMB = `data:image/svg+xml;utf8,${encodeURIComponent(
  `<svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44">
    <rect width="44" height="44" rx="6" fill="#fcfbfe"/>
    <path d="M10 32l8-10 6 7 5-6 7 8" fill="none" stroke="#8467c2" stroke-width="1.5" stroke-linecap="round"/>
    <circle cx="16" cy="14" r="3" fill="#8467c2"/>
  </svg>`
)}`;

/** Prefer catalog name when API sends productName (odos_merchant parity). */
export function orderLineDisplayLabel(item) {
  if (!item) return "";
  const n = item.productName != null ? String(item.productName).trim() : "";
  if (n) return n;
  return String(item.sku ?? "Item").trim() || "Item";
}

/** Absolute URL for small order-line thumbnails (paths from API). */
export function orderItemThumbnailSrc(rawPathOrUrl) {
  if (!rawPathOrUrl || !String(rawPathOrUrl).trim()) return DEFAULT_THUMB;
  const raw = String(rawPathOrUrl).trim();
  const abs = raw.startsWith("http") ? raw : apiUrl(raw.startsWith("/") ? raw : `/${raw}`);
  return safeProductOrProfileImageSrc(abs, DEFAULT_THUMB);
}
